import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box/Box';
import Card from '../components/Card/Card';

import { ResourcesText, ResourcesDescription, ResourcesTitle } from './PartialResources.style';

import { CARDS } from '../constants';
import { resourcesMeta } from 'constants/pages';
import { useMediaQuery } from '@mui/material';
import { theme } from 'styles/theme';
import { Button } from 'components/Buttons';

export const PartialResources: FC<{
  scrollToSection?: () => void;
}> = ({ scrollToSection }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isResourcesPage = resourcesMeta.url === location.pathname;
  const filteredCards = CARDS.filter((card) => card.postUrl !== location.pathname).sort((a, b) => {
    return new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime();
  });
  const isLessThan1024px = useMediaQuery(theme.breakpoints.down('md'));

  const cardsToShow = !isResourcesPage ? (isLessThan1024px ? 4 : 3) : 3;

  const handleViewAll = () => {
    if (scrollToSection) {
      scrollToSection();
    } else {
      navigate(resourcesMeta.url);
    }
  };

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        maxWidth="1200px"
        padding="80px 24px 112px"
      >
        <ResourcesText>Resources</ResourcesText>

        <ResourcesTitle>Explore Our Latest Insights</ResourcesTitle>

        <ResourcesDescription>
          Stay informed with our expert articles and updates.
        </ResourcesDescription>

        <Box
          display="grid"
          gridTemplateColumns={{
            xxs: '1fr',
            sm: '1fr',
            md: '1fr 1fr 1fr',
          }}
          justifyContent="center"
          gap={4}
          width="100%"
          margin="80px 0"
        >
          {filteredCards.slice(0, cardsToShow).map((card) => (
            <Card key={card.title} {...card} />
          ))}
        </Box>

        <Button width={129} onClick={handleViewAll}>
          View all
        </Button>
      </Box>
    </Box>
  );
};
